import { FCX, Tooltip } from "@datassential/platform-ui-lib";
import { ComponentProps, useMemo } from "react";
import HeatScoreLabel from "@vms/HeatScoreLabel";
import { useCommonDataContext } from "@core/CommonDataContext";
import { compareHeatScore, HEAT_SCORE_ORDER } from "@models/HeatScore";
import Popup from "@components/Popup";

const HeatScoreTooltip: FCX<ComponentProps<typeof Tooltip> & {
	change?: number | null,
	isMinimized?: boolean;
}> = ({
    id: tooltipId,
	isMinimized = false,
	change,
	...props
}) => {
    const {
        heatScoreTooltip,
        heatScores,
    } = useCommonDataContext();

    const heatScoresOptions = useMemo(
        () => {
            return (heatScores ?? [])
                .map((i) => ({
                    id: i.id ?? 0,
                    description: i.description,
                }))
                .sort((a, b) => {
                    return compareHeatScore(HEAT_SCORE_ORDER, a.id, b.id);
                });
        },
        [heatScores],
    );

	const changePercentage = useMemo(() => {
		const changeValue = +(change ?? 0)
		if (changeValue <= 0) return `${changeValue}%`

		return `+${changeValue}%`
	}, [change])

    return (
        <Popup>
            <Tooltip
                id={tooltipId}
                place="bottom-end"
                style={{
                    padding: 0,
                }}
                {...props}
            >
                <div
                    className="HeatScoreTooltip"
                    data-testid="blockHeatScoreTooltip"
                >
                    <div
                        className="HeatScoreTooltip__header"
                        dangerouslySetInnerHTML={{
                            __html: heatScoreTooltip ?? '',
                        }}
                    />
                    <div className="HeatScoreTooltip__content">
                        {isMinimized ? (
							<span>Know It (pt chg vs. 2 yrs ago): <strong>{changePercentage}</strong></span>
                        ) : (
	                        heatScoresOptions.map((i, index) => (
		                        <div
			                        key={i.id}
			                        className="HeatScoreTooltip__content-row"
		                        >
			                        <HeatScoreLabel
				                        heatScoreId={i.id}
				                        className="HeatScoreTooltip__content-label"
				                        testId={`textHeatScoreLabel${index}`}
                                        modifiers={["medium"]}
			                        />
			                        <div
				                        className="HeatScoreTooltip__content-description"
				                        data-testid={`textHeatScoreDescription${index}`}
			                        >
				                        {i.description}
			                        </div>
		                        </div>
	                        ))
                        )}
                    </div>
                </div>
            </Tooltip>
        </Popup>
    );
};

export default HeatScoreTooltip;